module.exports = __webpack_public_path__ + "static/media/mainimg-03.2c81cb5b.png";